import { classes } from "../../../../../../shared/react/react";
import { isMemberRole } from "../../roles";
import { GenericProps, EditorUser, HoldingRole } from "../../types";
import { UserRoleCell } from "./UserRoleCell";

interface Props extends GenericProps {
    user: EditorUser
}

export function UserRow(props: Props) {

    const { user, dispatch, state: { loggedInUser } } = props
    const { updated, deleted } = user
    const { ownerRole } = loggedInUser

    const self = loggedInUser.userId == user.userId

    const canToggleDelete = deleted || (
        ownerRole
        && isMemberRole(user.holdingRole)
        && (loggedInUser?.userId !== user.userId)
    )

    const toggleDelete = () => dispatch({ type: "updateUser", payload: { userId: user.userId, deleted: !user.deleted } })

    return <tr className={classes(updated && "updated", deleted && "deleted", self && "self")}>

        <td className="actions">
            {
                canToggleDelete &&
                <button type="button" className={classes("btn btn-icon delete", deleted && "danger")} onClick={toggleDelete} title="Remove">
                    <i className="fas fa-trash-alt"></i>
                </button>
            }
        </td>

        <td>{user.displayName}</td>
        <td>{user.email}</td>

        <UserRoleCell {...props} />

    </tr >

}
